export default __webpack_public_path__ + "static/media/session10.ad735ae9.svg";